
<template>
  <div class="order-summary">
    <div v-if="cartIsEmpty">
      <div class="section-heading">
        <h3>Your Cart is Empty</h3>
      </div>
      <div class="action-item card">
        <router-link class="card-body" to="/call-center">
          <!-- <h1>Build Your Deal</h1> -->
          <h1>Build Your Own</h1>
          <p>Like Build-A-Bear, but with deals.</p>
          <button class="btn btn-sm btn-light">Get Creative</button>
        </router-link>
      </div>
    </div>
    <div v-if="!cartIsEmpty">
      <div class="section-heading">
        <h3>Order Summary</h3>
      </div>

      <table class="table top-heading">
        <thead>
          <tr>
            <th class="details">Deals</th>
            <th class="value">Once-Off</th>
            <th class="value">Monthly</th>
          </tr>
        </thead>
      </table>

      <div class="items">
        <order-summary-item
          v-for="sim in cartSims"
          v-bind:key="sim.id"
          :item="sim"
          :connectionFee="sim.connection_fee"
        ></order-summary-item>
      </div>

      <table class="table" v-if="cartTotals.sub_total.delivery > 0">
        <tbody>
          <tr>
            <th class="details">Delivery</th>
            <th class="value">{{ cartTotals.sub_total.delivery | currency }}</th>
            <th class="value"></th>
          </tr>
        </tbody>
      </table>

      <table class="table">
        <thead>
          <tr>
            <th class="details">Sub Total</th>
            <th class="value">{{ cartTotals.sub_total.once_off | currency }}</th>
            <th class="value">{{ cartTotals.sub_total.monthly | currency }}</th>
          </tr>
          <tr class="bottom">
            <th class="details"></th>
            <th>Once-Off</th>
            <th>Monthly</th>
          </tr>
        </thead>
      </table>

      <div class="section-heading total">
        <a class="badge badge-primary clear-all" @click="toggle_block=true">
          Clear All
          <span class="fa fa-trash"></span>
        </a>
        <table class="table">
          <thead>
            <tr>
              <th>
                <h3>Due Now</h3>
              </th>
              <th>
                <h3 class="text-right">{{ cartTotals.total | currency }}</h3>
              </th>
            </tr>
          </thead>
        </table>        
      </div>
    </div>

    <div class="bottom"></div>
    <vue-block :classname="'align-items-center justify-content-center'" :toggle.sync="toggle_block">
      <div class="remove-container">
        <h4>Clear your cart?</h4>   
        <div>
          <button class="btn btn-outline-light btn-sm" @click="clearCart">Yes</button>
          <button class="btn btn-outline-light btn-sm" @click="toggle_block = !toggle_block">No</button>
        </div>     
      </div>
    </vue-block>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  CART_RESET
} from "@/store/actions.type";

import OrderSummaryItem from "./order-summary-item.vue";

export default {
  name: "order-summary",
  components: {
    "order-summary-item": OrderSummaryItem
  },
  data() {
    return {
      toggle_block: false
    };
  },
  computed: {
    ...mapGetters(["cartTotals", "cartSims"]),
    cartIsEmpty() {
      var self = this;
      return (
        self.cartSims == null ||
        typeof self.cartSims == "undefined" ||
        self.cartSims.length < 1
      );
    }
  },
  methods: {
    isEmpty: function(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },
    clearCart: function() {
      var self = this;
      self.toggle_block = !self.toggle_block;
      store.dispatch(CART_RESET);
    }
  }
};
</script>